import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import _ from "lodash";
import uuid from "react-uuid";
import Loading from "../../../common/components/loading/loading";
import { getRoles } from "../../../common/services/auth/roleService";
import SearchBox from "../../../common/components/search/searchBox";
import RolesTable from "./rolesTable";
import { withTranslation } from "react-i18next";

class Roles extends Component {
  constructor(props) {
    super(props);

    this.handleRoleUpdated = this.handleRoleUpdated.bind(this);
  }

  state = {
    roles: [],
    searchQuery: "",
    activeOnly: true,
    sortColumn: { path: "name", order: "asc" },
    isLoading: true,
  };

  async componentDidMount() {
    this.setState({ roles: await getRoles(), isLoading: false });
  }

  handleSearch = (query) => {
    this.setState({ searchQuery: query });
  };

  handleSort = (colId, sort) => {
    if (colId && sort) {
      this.setState({
        sortColumn: {
          path: colId,
          order: sort,
        },
      });
    }
  };

  handleToggleActiveOnly = () => {
    this.setState({ activeOnly: !this.state.activeOnly });
  };

  handleRoleSelected = (role, isNew = false) => {
    //Inject the callback function before calling back to the onClick event.
    this.props.onClick(role, this.handleRoleUpdated, isNew);
  };

  handleRoleUpdated = (role) => {
    const roles = [...this.state.roles];
    const index = roles.findIndex((u) => u.roleId === role.roleId);
    if (index > -1) {
      roles.splice(index, 1);
    }
    roles.push(role);
    this.setState({ roles: roles });
  };

  getFilteredData = () => {
    const { sortColumn, searchQuery, roles: allRoles, activeOnly } = this.state;

    let filtered = allRoles;

    if (activeOnly) filtered = filtered.filter((u) => u.active);

    if (searchQuery)
      filtered = filtered.filter(
        (u) =>
          u.name != null &&
          u.name.toLowerCase().includes(searchQuery.toLowerCase())
      );

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    return { totalCount: filtered.length, data: sorted };
  };

  render() {
    const { searchQuery, activeOnly, isLoading } = this.state;

    if (isLoading) return <Loading />;

    const { t, allowEdit } = this.props;

    const { totalCount, data: roles } = this.getFilteredData();

    const newRole = {
      roleId: uuid(),
      name: t("NewRole"),
    };

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <SearchBox value={searchQuery} onChange={this.handleSearch} />
          </div>
          <div className="col">
            <Form.Switch
              className="switch"
              type="switch"
              label={t("ActiveOnly")}
              checked={activeOnly}
              value={activeOnly}
              onChange={this.handleToggleActiveOnly}
            />
          </div>
          <div className="col">
            {allowEdit && (
              <button
                onClick={() => this.handleRoleSelected(newRole, true)}
                className="btn btn-sm btn-primary float-sm-right"
              >
                {t("AddRole")}
              </button>
            )}
          </div>
        </div>
        <p>{t("RetrievedRole", { count: totalCount })}</p>
        <RolesTable
          roles={roles}
          onSort={this.handleSort}
          onRowClick={this.handleRoleSelected}
        />
      </div>
    );
  }
}

export default withTranslation(["auth"])(Roles);
